<template>
  <div class="banner">
    <div class="text">
      <Form v-if="showForm" @msg="msg => $emit('msg', msg)" :landingPageName="landingPageName" />
      <div class="banner_tabbox">
        <div class="tab_listbox">
          <div class="list_block" v-for="(item, index) in list" :key="index">
            <div class="list_year">{{ item[0] }}</div>
            <div class="list_con">{{ item[1] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showForm: Boolean,
    list: Array,
    video: String,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  components: {
    Form: () => import('./Form.vue'),
  },
}
</script>

<style lang="less" scoped>
.banner {
  height: 580px;
  // position: relative;
  // margin-top: -90px;
  // overflow: hidden;
  width: 100%;
  background: no-repeat center / cover url(../../../assets/images/real-estate/ban-bj.png);

  source {
    min-width: 100%;
    min-height: 580px;
    height: auto;
    width: auto;
  }

  .text {
    width: 100%;
    height: 580px;
    color: #fff;
    font-size: 56px;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;
    position: absolute;
    display: flex;
    justify-content: center;
  }
  .banner_tabbox {
    width: 100%;
    height: 80px;
    background: rgba(0, 0, 0, 0.59);
    position: absolute;
    bottom: 10px;
    color: #fff;
    text-align: center;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
  }
  .tab_listbox {
    height: 80px;
    display: flex;

    .list_block {
      width: 236px;
      font-size: 24px;
      line-height: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #fff;
      height: 80px;
      padding-top: 12px;

      .list_year {
        font-weight: 600;
      }
      .list_con {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        padding-top: 4px;
        font-size: 14px;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
